import React, {Fragment, useEffect} from 'react';
import AppHeader from '../components/global/AppHeader';
import Hero from '../components/hero/ImpactHero';
import SectorsNavBar from '../components/SectorsNavBar';
import ProductionTotal from '../components/impact/ProductionTotal';
import StatesDistribution from '../components/impact/StatesDistribution';
import BeneficiaryGroup from '../components/impact/BeneficiaryGroup';
import BeneficiaryScroll from '../components/impact/BeneficiaryScroll';
import ImpactGroup from '../components/impact/ImpactGroup';
import WhatNext from '../components/impact/WhatNext';
import PressLinks from '../components/PressLinks';
import {generalStats as statistics} from '../data/impact';
import ProgressBar from 'react-scroll-progress-bar';

function Impact() {
	useEffect(() => {
		document.body.classList.remove('is-dark');
		const handleScroll = (e) => {
			if (window.scrollY >= 2000) {
				document.body.classList.add('is-bottom');
			} else {
				document.body.classList.remove('is-bottom');
			}
		};
		document.addEventListener('scroll', handleScroll);
		return () => {
			document.removeEventListener('scroll', handleScroll);
		};
	}, []);

	const handleScrollToTop = () => {
		window.scrollTo({
			top: 0,
			behavior: 'smooth',
		});
	};

	return (
		<Fragment>
			<Hero>
				<AppHeader />
			</Hero>
			<div className="progress-bar">
				<ProgressBar bgcolor="#403d3d" />
			</div>
			<main id="main" role="main">
				<SectorsNavBar />

				<div id="access-to-ppe">
					<div id="total">
						<ProductionTotal />
					</div>
					<StatesDistribution />
					<BeneficiaryGroup>
						<BeneficiaryScroll />
					</BeneficiaryGroup>
				</div>

				<div id="economic-empowerment">
					<section id="video-wrapper">
						<div className="container">
							<div className="video__wrapper">
								<iframe
									width="560"
									height="661"
									src="https://www.youtube.com/embed/lYtqmI_Sq3k?rel=0&controls=1&autoplay=0&modestbranding=1"
									title="YouTube video player"
									frameBorder="0"
									allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
									allowFullScreen></iframe>
							</div>
							<small className="caption">
								We take a look back at internal beneficiaries of this project and discuss the impact of the
								projects on their lives.
							</small>
						</div>
					</section>
				</div>

				<div id="job-creation">
					<section id="statistics">
						<div className="container container--md">
							{statistics.slice(0, 3).map((item, index) => (
								<ImpactGroup key={index} details={item.details} image={item.image} />
							))}
						</div>
					</section>
				</div>

				<div className="container container--md">
					<hr />
				</div>

				<div id="upskilling">
					<section id="training">
						<div className="container container--md">
							{statistics.slice(3).map((item, index) => (
								<ImpactGroup key={index} details={item.details} image={item.image} />
							))}
						</div>
					</section>
				</div>

				<WhatNext />
				<PressLinks />
			</main>
			<div className="back-to-top" onClick={handleScrollToTop}>
				<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="40" height="40" fill="#3d3d3d" viewBox="0 0 50 50">
					<path d="M4,9v32c0,2.76,2.24,5,5,5h32c2.76,0,5-2.24,5-5V9c0-2.76-2.24-5-5-5H9C6.24,4,4,6.24,4,9z M37.71,29.29 C37.9,29.49,38,29.74,38,30s-0.1,0.51-0.29,0.71c-0.39,0.39-1.03,0.39-1.42,0L25,19.41l-11.29,11.3c-0.39,0.39-1.03,0.39-1.42,0 c-0.39-0.39-0.39-1.03,0-1.42L25,16.59L37.71,29.29z"></path>
				</svg>
			</div>
		</Fragment>
	);
}

export default Impact;
